import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { updateAppVersion, addAppVersion } from "../../actions";
import { validateAppVersionsOnChange, validateAppVersion } from "../../validators";

export const useAddUpdateAppVersionHook = ({
   selectedAppVersionData = {},
   isModalOpen = false,
   isEdit = false,
   handleSubmit = () => { }
}) => {

   const intialAppVersionData = {
      version_id: null,
      os: "IOS",
      versionCode: "",
      versionName: "",
      required: true,
      description: "",
   }
   const operatingSystemList = [
      {
         label: "IOS",
         value: "IOS"
      },
      {
         label: "Android",
         value: "ANDROID"
      }
   ]
   const [appVersionData, setAppVersionData] = useState({})
   const [isLoading, setIsLoading] = useState(false);
   const [errorMessages, setErrorMessages] = useState({});

   useEffect(() => {
      if (isEdit && isModalOpen) {
         setAppVersionData({
            ...selectedAppVersionData,
            version_id: selectedAppVersionData.version_id || null,
            os: selectedAppVersionData.os || "IOS",
            versionCode: selectedAppVersionData.versionCode || "",
            versionName: selectedAppVersionData.versionName || "",
            required: selectedAppVersionData.required || false,
            description: selectedAppVersionData.description || "",
         })
         setErrorMessages({})
      } else {
         setAppVersionData({ ...intialAppVersionData })
         setErrorMessages({})
      }
   }, [selectedAppVersionData, isModalOpen])

   const handleInputChange = (event) => {
      const { name, value } = event.target

      const errors = validateAppVersionsOnChange(name, value, errorMessages)
      setErrorMessages({ ...errors })
      setAppVersionData({
         ...appVersionData,
         [name]: value
      })
   }

   const handleSelectChange = (selectedValue, name) => {
      const errors = validateAppVersionsOnChange(name, selectedValue, errorMessages)
      setErrorMessages({ ...errors })
      setAppVersionData({
         ...appVersionData,
         [name]: selectedValue
      })
   }

   const handleSwitchChange = (selectedValue, name) => {
      const errors = validateAppVersionsOnChange(name, selectedValue, errorMessages)
      setErrorMessages({ ...errors })
      setAppVersionData({
         ...appVersionData,
         [name]: selectedValue
      })
   }

   const handleAppVersionSubmit = async () => {
      try {
         const errors = validateAppVersion(appVersionData)
         setErrorMessages(errors)

         if (Object.keys(errors).length > 0) {
            return;
         }

         setIsLoading(true)
         const appVersionPayload = {
            os: appVersionData.os || "IOS",
            versionCode: appVersionData.versionCode || "",
            versionName: appVersionData.versionName || "",
            required: appVersionData.required || false,
            description: appVersionData.description || "",
         }

         let appVersionRes
         if (selectedAppVersionData.version_id) {
            appVersionRes = await updateAppVersion(selectedAppVersionData.version_id, appVersionPayload)
         } else {
            appVersionRes = await addAppVersion(appVersionPayload)
         }
         toast.success("Version details stored.")

         handleSubmit()
      } catch (error) {
         console.log({
            error
         });
         toast.error("Error while submiting version data.")
      } finally {
         setIsLoading(false)
      }
   }

   return {
      isLoading,
      appVersionData,
      operatingSystemList,
      errorMessages,
      handleInputChange,
      handleSelectChange,
      handleSwitchChange,
      handleAppVersionSubmit
   }
}